export enum ThemeNames {
  GARANT = 'garant',
  PRUEM = 'pruem'
}
